import React, { useEffect, useState, useCallback } from "react";
import { Link } from "react-router-dom";
import PageHero from "../components/PageHero";
import Reveal from "../components/Reveal";
import api from "../lib/api";
import useSeo from "../hooks/useSeo";
import { ArrowRight, Calendar, Loader2 } from "lucide-react";

const Blog = () => {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  useSeo({
    metaTitle: "Blog \u2014 Cricket ID Tips & Guides | DaddyAnna",
    metaDescription: "Read the latest guides on online cricket id, betting tips and DaddyAnna updates.",
    metaKeywords: "cricket id, online cricket id, daddyanna, blog",
  }, "Blog | DaddyAnna");

  const loadPosts = useCallback(() => {
    api.get("/blog").then(({ data }) => setPosts(data)).catch(() => {}).finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    loadPosts();
  }, [loadPosts]);

  return (
    <main>
      <PageHero
        crumb="Blog"
        title="DaddyAnna"
        highlight="Blog"
        subtitle="Guides, tips and updates on online cricket id, betting exchanges and casino games."
      />
      <section className="pb-24">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          {loading ? (
            <div className="flex justify-center py-20"><Loader2 className="animate-spin text-[#00ff87]" size={36} /></div>
          ) : posts.length === 0 ? (
            <p className="text-center text-gray-400 py-20">No blog posts yet. Check back soon!</p>
          ) : (
            <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-7">
              {posts.map((p, i) => (
                <Reveal key={p.id} delay={i * 80}>
                  <Link to={`/blog/${p.slug}`} className="card-neon rounded-2xl overflow-hidden h-full flex flex-col group">
                    {p.coverImage && (
                      <div className="h-44 overflow-hidden bg-[#0a0a13]">
                        <img src={p.coverImage} alt={p.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                      </div>
                    )}
                    <div className="p-6 flex flex-col flex-1">
                      <div className="flex items-center gap-2 text-xs text-gray-500 mb-3">
                        <Calendar size={13} /> {new Date(p.createdAt).toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric" })}
                      </div>
                      <h3 className="font-display font-semibold text-lg text-white mb-2 leading-snug group-hover:text-[#00ff87] transition-colors">{p.title}</h3>
                      <p className="text-gray-400 text-sm leading-relaxed line-clamp-3">{p.excerpt}</p>
                      <span className="mt-4 inline-flex items-center gap-1.5 text-[#00ff87] text-sm font-semibold">
                        Read more <ArrowRight size={15} />
                      </span>
                    </div>
                  </Link>
                </Reveal>
              ))}
            </div>
          )}
        </div>
      </section>
    </main>
  );
};

export default Blog;
